import { TEACHER_ROUTE } from 'app/teacher/routing-constants/teacher-routing.constant';

export const MISSION_REPORT_ROUTE = {
  name: 'missionreport/:missionId',
  route(classId: string, missionId: string): string[] {
    return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), 'missionreport', missionId];
  }
};
export const MISSION_REPORT_EDIT_ROUTE = {
  name: 'missionreport/:missionId',
  route(classId: string, missionId: string): string[] {
    return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), 'missionreport', missionId, 'edit'];
  }
};